import { Injectable } from '@angular/core';
import { CustomerAddress } from '../models/customer-address';

@Injectable({
  providedIn: 'root'
})
export class CustomerAddressService 
{
  customerAddress:CustomerAddress | undefined;
  
  constructor() { }

  public setCustomerAddress(address:CustomerAddress)
  {
    this.customerAddress = address;
  }

  public getCustomerAddress()
  {
    return this.customerAddress;
  }
}
